import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  Home, 
  CalendarDays,
  Euro,
  Settings,
  User
} from 'lucide-react';

const BottomNav = () => {
  const { user } = useAuth();

  const isTechWithHousekeeping = user?.role === 'technicien' && user?.is_also_housekeeper;

  const navItems = [
    { to: '/app', icon: Home, label: 'Accueil', exact: true },
    { to: '/app/tasks', icon: CalendarDays, label: 'Missions' },
    { to: '/app/earnings', icon: Euro, label: 'Revenus' },
    { to: '/app/profile', icon: User, label: 'Profil' },
    ...(isTechWithHousekeeping ? [
      { to: '/tech', icon: Settings, label: 'Admin' }
    ] : []),
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-slate-200/80 shadow-[0_-8px_30px_-15px_rgba(0,0,0,0.1)] z-50">
      <div className="flex items-center justify-around h-20 max-w-lg mx-auto px-2 pb-safe">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact}
            className={({ isActive }) => `
              flex flex-col items-center justify-center flex-1 h-full py-2 transition-all duration-300 ease-out
              ${isActive 
                ? 'text-blue-900' 
                : 'text-slate-400'
              }
            `}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            {({ isActive }) => (
              <>
                <div className={`
                  w-14 h-14 flex items-center justify-center rounded-2xl transition-all duration-300 ease-out
                  ${isActive 
                    ? 'bg-gradient-to-br from-blue-600 to-indigo-700 text-white shadow-xl shadow-blue-600/40 -translate-y-2 scale-105' 
                    : 'bg-transparent hover:bg-slate-100'
                  }
                `}>
                  <item.icon className={`h-6 w-6 ${isActive ? 'stroke-[2.5]' : 'stroke-[1.5]'}`} />
                </div>
                <span className={`text-[11px] mt-1 font-bold tracking-tight transition-colors ${isActive ? 'text-blue-900' : 'text-slate-400'}`}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
